export const useDefaultData = ({Helpers}) => {

    const { getCurrentDate } = Helpers
    
    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idagenda: '',
        origen: 'MANUAL',
        tipo_evento: '',
        datos_cliente: '',
        fecha_evento: getCurrentDate(),
        descripcion: ''
    }


    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}